var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "640",
      "persistent": _vm.submitting
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h6"
  }, [_vm._v(_vm._s(_vm.$t('elabel_export_new')))]), _c('v-card-text', {
    staticClass: "mt-4 pb-0"
  }, [!_vm.singleCampaign ? _c('div', [_c('div', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns')))]), _c('v-autocomplete', {
    staticClass: "scope-field",
    attrs: {
      "items": _vm.campaigns,
      "placeholder": _vm.$t('elabel_export_choose_campaigns'),
      "item-text": "name",
      "item-value": "id",
      "data-test": "campaigns-field",
      "outlined": "",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "small-chips": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([_vm.allCampaignsSelected ? {
      key: "selection",
      fn: function (_ref) {
        var index = _ref.index;
        return [index === 0 ? _c('v-chip', {
          attrs: {
            "small": "",
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              _vm.selectedCampaigns = [];
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('elabel_export_all_campaigns')))]) : _vm._e()];
      }
    } : null, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          on: {
            "click": _vm.toggleAllCampaigns
          }
        }, [_c('v-list-item-action', [_c('v-checkbox', {
          attrs: {
            "input-value": _vm.allCampaignsSelected,
            "hide-details": "",
            "dense": ""
          }
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('select_all')))])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selectedCampaigns,
      callback: function ($$v) {
        _vm.selectedCampaigns = $$v;
      },
      expression: "selectedCampaigns"
    }
  })], 1) : _vm._e(), _vm.singleCampaign ? [_c('div', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('brands')))]), _c('v-autocomplete', {
    staticClass: "scope-field",
    attrs: {
      "items": _vm.brandItems,
      "loading": _vm.loadingBrands,
      "placeholder": _vm.$t('elabel_export_choose_brands'),
      "item-text": "name",
      "item-value": "id",
      "data-test": "brands-field",
      "outlined": "",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "small-chips": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([_vm.allBrandsSelected ? {
      key: "selection",
      fn: function (_ref2) {
        var index = _ref2.index;
        return [index === 0 ? _c('v-chip', {
          attrs: {
            "small": "",
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              _vm.selectedBrands = [];
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('brand_all_brands')))]) : _vm._e()];
      }
    } : null, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          on: {
            "click": _vm.toggleAllBrands
          }
        }, [_c('v-list-item-action', [_c('v-checkbox', {
          attrs: {
            "input-value": _vm.allBrandsSelected,
            "hide-details": "",
            "dense": ""
          }
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('select_all')))])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selectedBrands,
      callback: function ($$v) {
        _vm.selectedBrands = $$v;
      },
      expression: "selectedBrands"
    }
  })] : _vm._e(), _c('div', {
    staticClass: "field-label mt-4"
  }, [_vm._v(_vm._s(_vm.$t('products')))]), _c('v-autocomplete', {
    staticClass: "scope-field",
    attrs: {
      "search-input": _vm.productSearch,
      "items": _vm.productItems,
      "loading": _vm.loadingProducts,
      "disabled": _vm.productsLocked,
      "placeholder": _vm.$t(_vm.productsLocked ? _vm.lockedProductsPlaceholderKey : 'elabel_export_all_products'),
      "item-text": _vm.productLabel,
      "item-disabled": _vm.isProductDisabled,
      "item-value": "id",
      "data-test": "products-field",
      "no-filter": "",
      "outlined": "",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "small-chips": "",
      "hide-details": "auto"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.productSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.productSearch = $event;
      },
      "blur": function ($event) {
        _vm.productSearch = '';
      }
    },
    model: {
      value: _vm.selectedProducts,
      callback: function ($$v) {
        _vm.selectedProducts = $$v;
      },
      expression: "selectedProducts"
    }
  }), _vm.productsAtLimit ? _c('div', {
    staticClass: "caption grey--text text--darken-1 mt-1",
    attrs: {
      "data-test": "products-limit"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_max_products', {
    count: _vm.productLimit
  })) + " ")]) : _vm._e(), _vm.hasSelection ? _c('p', {
    staticClass: "body-2 black--text mt-6 mb-0",
    attrs: {
      "data-test": "selection-sentence"
    }
  }, [_vm._v(_vm._s(_vm.sentence))]) : _vm._e()], 2), _c('v-card-actions', {
    staticClass: "pa-4 px-6 pb-6"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "blue--text mr-4",
    attrs: {
      "text": "",
      "disabled": _vm.submitting,
      "data-test": "cancel-export"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.submitting,
      "disabled": _vm.createDisabled,
      "data-test": "submit-export"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_create')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }